<script setup>
import { ref, onMounted } from 'vue'
import {
  DxChart,
  DxSeries,
  DxLegend,
  DxTooltip,
  DxCommonSeriesSettings,
  DxLabel,
} from 'devextreme-vue/chart'
import { getCssVar } from 'quasar'
import { planningApi } from '@/apis/planning.api'

const data = ref(null)

const COLORS = {
  Active: getCssVar('primary'),
  Completed: '#1565C0',
  Archived: '#BDBDBD',
}

const DEFINITIONS = {
  Active: 'Planned, Pre-Production, Production, Post-Production',
  Completed: 'Completed status, not yet archived',
  Archived: 'Archived projects',
}

onMounted(async () => {
  const res = await planningApi.getProjectActiveSummaryAsync()
  data.value = [
    { category: 'Active',    value: res.data.active },
    { category: 'Completed', value: res.data.completed },
    { category: 'Archived',  value: res.data.archived },
  ]
})

const customizePoint = ({ argument }) => ({ color: COLORS[argument] })

const customizeTooltip = ({ argument, value }) => ({
  text: `${argument} (${value})\n${DEFINITIONS[argument]}`,
})
</script>

<template>
  <div class="fit column" style="padding-left: 8px">
    <div v-if="data === null" class="col flex flex-center">
      <q-spinner size="md" color="primary" />
    </div>
    <dx-chart
      v-else
      :data-source="data"
      class="col"
      :customize-point="customizePoint"
      :bar-group-padding="0.5"
      :bar-group-width="40"
    >
      <dx-common-series-settings type="bar">
        <dx-label :visible="true" />
      </dx-common-series-settings>
      <dx-series argument-field="category" value-field="value" />
      <dx-legend :visible="false" />
      <dx-tooltip :enabled="true" :customize-tooltip="customizeTooltip" />
    </dx-chart>
  </div>
</template>
